import {
  FETCH_SHOP_THE_LOOK_SUCCESS,
  FETCH_SHOP_THE_LOOK_FAILURE,
  FETCH_SHOP_THE_LOOK_REQUEST,
  UPDATE_SHOP_THE_LOOK
} from '../../actionTypes/shopTheLookActionTypes'

const initialState = {
  data: {},
  meta: {}
}

const getShopTheLookSkus = syteResponse => {
  //  remove duplicated categories
  let syteData = syteResponse.filter(
    (element, index, array) => array.findIndex(element2 => element2.label === element.label) === index
  )

  // remove recs with empty ads array
  syteData = syteData.filter(category => category.ads.length)
  const recs = []
  const numOfCategories = syteData.length
  let recsCount = 0
  const maxRecs = 4 // number of recs to show
  let categoryIndex = 0
  let adsIndex = 0
  // Keep taking one sku from each rec category until maxRecs is reached or break if sku undefined
  while (recsCount < maxRecs) {
    const sku = syteData[categoryIndex % numOfCategories].ads[adsIndex]?.sku

    if (!sku) break

    const duplicateSkuFound = recs.some(rec => rec.sku === sku)
    if (sku && !duplicateSkuFound) {
      recs.push({
        sku
      })
      recsCount += 1
    }
    categoryIndex += 1

    if (categoryIndex === numOfCategories) {
      categoryIndex = 0
      adsIndex += 1
    }
  }
  return recs
}

const transformData = ({ partNumber, type, syteResponse }) => {
  syteResponse = getShopTheLookSkus(syteResponse)
  const transformedData = syteResponse.map(rec => ({
    id: rec.sku,
    type,
    attributes: {
      score: 0
    },
    meta: {
      entity: partNumber
    }
  }))
  return transformedData
}

const buildRequestState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {})
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: false
      }
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber } = payload
  const recommendedProducts = transformData(payload)

  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        products: recommendedProducts
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: true
      }
    }
  }
  return newState
}

const buildFailureState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber, errorDetail } = payload

  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {})
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail,
        requestDone: true
      }
    }
  }
  return newState
}

const updateShopTheLook = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber, data: payloadData = {} } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {}),
        ...payloadData
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        requestDone: true
      }
    }
  }
  return newState
}

const shopTheLookReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_SHOP_THE_LOOK_SUCCESS:
      return buildSuccessState(state, payload)

    case FETCH_SHOP_THE_LOOK_FAILURE:
      return buildFailureState(state, payload)

    case FETCH_SHOP_THE_LOOK_REQUEST:
      return buildRequestState(state, payload)

    case UPDATE_SHOP_THE_LOOK:
      return updateShopTheLook(state, payload)

    default:
      return state
  }
}

export { initialState, shopTheLookReducer }
